import React, { Component } from 'react';
import { Spin } from 'antd';

const withLoading = WrappedComponent =>
  class extends Component {
    state = {
      isShowLoading: false
    };

    setLoading = isShowLoading => {
      this.setState({
        isShowLoading
      });
    };

    render() {
      return (
        <Spin tip="Memuat..." spinning={this.state.isShowLoading}>
          <WrappedComponent setLoading={this.setLoading} {...this.props} />
        </Spin>
      );
    }
  };

export default withLoading;
